import React, { useCallback, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import { Box } from "@material-ui/core";
import { useProjectsForProgram } from "./cspServices";
import TotalsHeader from "../creator-application/common/TotalsHeader";
import PanelLoadingIndicator from "../components/PanelLoadingIndicator";
import { isBlank, notBlank } from "../util/ext";
import ProjectTable from "./ProjectTable";
import { useHistory, useLocation } from "react-router-dom";
import NewProjectDialog from "./edit/NewProjectDialog";

const useStyles = scrollVisible =>
  makeStyles(theme => ({
    panel: {
      paddingLeft: theme.spacing(4),
      paddingRight: scrollVisible ? theme.spacing(0) : theme.spacing(4),
    },
  }));

const ProgramProjectContainer = ({ programId, programName, programKey }) => {
  const [scrollVisible, setScrollVisible] = useState(true);
  const classes = useStyles(scrollVisible)();
  const history = useHistory();
  const location = useLocation();

  const [projects, setProjects] = useState([]);
  const projectsResponse = useProjectsForProgram(programId);
  useEffect(() => {
    if (projectsResponse.isSuccess) {
      setScrollVisible(false);
      setProjects(projectsResponse.data);
    }
  }, [projectsResponse.data, projectsResponse.isSuccess]);

  const handleScrollVisible = useCallback(visible => {
    setScrollVisible(visible);
  }, []);

  const [dialogOpen, setDialogOpen] = useState(false);
  const handleNewProjectClicked = useCallback(value => {
    setDialogOpen(true);
  }, []);

  const handleNewCancel = useCallback(() => {
    setDialogOpen(false);
  }, []);

  const handleNewSave = useCallback(
    data => {
      setDialogOpen(false);
      history.push(
        `/manage-csp/programs/${data.programId}/projects/${data.projectId}`,
        {
          previousLocation: location.pathname,
        },
      );
    },
    [history, location.pathname],
  );

  return (
    <Container id="project-browse-view" classes={{ root: classes.panel }}>
      <Box>
        <TotalsHeader
          countText="Project"
          count={projectsResponse.isSuccess ? projects.length : 0}
          selectedActions={
            <Box>
              <Button
                variant={"text"}
                startIcon={<AddIcon />}
                onClick={handleNewProjectClicked}
              >
                New Project
              </Button>
            </Box>
          }
        />
        <Container classes={{ root: classes.panel }}>
          {projectsResponse.isError && (
            <Box padding={5} color="error" fontSize="1.4rem" fontStyle="italic">
              Error loading Projects.
            </Box>
          )}
          {projectsResponse.isLoading && <PanelLoadingIndicator />}
          {projectsResponse.isSuccess && isBlank(projects) && (
            <Box padding={5} fontSize="1.4rem" fontStyle="italic">
              No Projects have been created for this Program.
            </Box>
          )}
          {projectsResponse.isSuccess && notBlank(projectsResponse) && (
            <ProjectTable
              program={{
                name: programName,
                id: programId,
                key: programKey,
              }}
              projects={projects}
              onScrollVisible={handleScrollVisible}
            />
          )}
        </Container>
      </Box>
      {dialogOpen && (
        <NewProjectDialog
          open={dialogOpen}
          program={programId}
          onCancel={handleNewCancel}
          onApply={handleNewSave}
        />
      )}
    </Container>
  );
};

export default ProgramProjectContainer;
